import { fetchScoring as fetchScoringApi } from 'support/api/VideoApi';
import { HttpClient } from 'support/api/api-types';

export const SCORING = 'SCORING' as const;

export const fetchScoring = () => ({
  type: SCORING,
  promise: (httpClient: HttpClient) => fetchScoringApi(httpClient),
});
